const COLLAPSED_STORAGE_KEY = 'erp:siderCollapsed';

/** The collapse choice of this browser. The sidebar starts expanded. */
export const readSiderCollapsed = (): boolean => {
  try {
    return window.localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const saveSiderCollapsed = (isCollapsed: boolean): void => {
  try {
    window.localStorage.setItem(COLLAPSED_STORAGE_KEY, String(isCollapsed));
  } catch {
    // Storage can be full or blocked: the sidebar then starts expanded next time.
  }
};
